import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSketchbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sketchbook"} maskId="square-filled-radius-0-stroke-1-IconSketchbook"><path fillRule="evenodd" clipRule="evenodd" d="M3.5 2.5H20.5V21.5H3.5V2.5ZM8 7H16V8H8V7ZM8 11H13V12H8V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSketchbook;
